<template>



    <div class="w1200 audition-page">



        <div class="audition-lottery audition-lottery-top">

            <span

                v-for="item in lotteryOptions"

                :key="item.dictValue"

                :class="{ active: lotteryActive === item.dictValue }"

                @click="toggleLottery(item.dictValue)">{{ item.dictLabel }}</span>

        </div>



        <period-summary :period="period" :lottery-options="lotteryOptions" show-empty />

        <div class="audition-intro">
            <div class="intro-title">活动介绍</div>
            <ul class="intro-list">
                <li>仅支持双色球与大乐透前区（红球），面向认证用户征集万元级实战投注单（约 9,500～10,500 元）。</li>
                <li>开奖后按红球/前区命中个数计算本期积分：双色球 6 个=二等奖金额、5 个=200、4 个=10、3 个=5；大乐透前区 5 个=二等奖金额、4 个=200、3 个=10、2 个=5。</li>
                <li>排名依据往期累计积分，积分越高越靠前；多组红表/前区条件取最大命中数。</li>
                <li>认证缩水师/技巧师或满足条件的用户可提交方案，审核通过后参与当期排行。</li>
            </ul>
        </div>

        <div class="audition-toolbar">



            <div class="toolbar-right">



                <el-select v-model="sort" size="small" style="width:130px">



                    <el-option label="累计积分" value="score" />



                    <el-option label="本期积分" value="period" />



                    <el-option label="最新" value="latest" />



                    <el-option label="奖金预期" value="prize" />



                </el-select>



                <span class="apply_sss primary" :class="{ disabled: !periodOperable }" @click="goSubmit">提交方案</span>



                <span class="apply_sss" @click="$router.push('/hxwysz')">返回栏目</span>



            </div>



        </div>







        <entry-rank-list



            :period-id="periodId"



            :period-name="periodName"



            :lottery-options="lotteryOptions"



            :lottery-active="lotteryActive"



            :sort="sort" />



    </div>



</template>







<script>



import { getLatestPeriod } from '@/api/audition'



import { queryLotteryType } from '@/api/common'



import PeriodSummary from './components/PeriodSummary.vue'



import EntryRankList from './components/EntryRankList.vue'



import { isPeriodOperable, ALLOWED_PRE_TYPES, filterAuditionLotteryOptions } from './utils'

export default {



    components: { PeriodSummary, EntryRankList },



    data () {



        return {



            period: null,



            periodId: null,



            periodName: '',



            lotteryOptions: [],



            lotteryActive: '',



            sort: 'score'



        }



    },



    computed: {



        periodOperable () {



            return isPeriodOperable(this.period)



        }



    },



    mounted () {



        const q = this.$route.query



        if (q.sort) this.sort = q.sort



        if (q.preType) this.lotteryActive = q.preType



        this.loadLotteryTypes().then(() => {



            this.initPeriod()



        })



    },



    methods: {



        loadLotteryTypes () {



            return queryLotteryType().then(res => {



                if (res && res.code === 200) {



                    this.lotteryOptions = filterAuditionLotteryOptions(res.data)

                    if (!this.lotteryActive && this.lotteryOptions.length) {

                        this.lotteryActive = this.lotteryOptions[0].dictValue

                    } else if (this.lotteryActive && !ALLOWED_PRE_TYPES.includes(this.lotteryActive)) {

                        this.lotteryActive = this.lotteryOptions.length ? this.lotteryOptions[0].dictValue : ''

                    }



                }



            }).catch(() => {})



        },



        initPeriod () {



            if (!this.lotteryActive) return



            getLatestPeriod(this.lotteryActive).then(res => {



                if (res && res.code === 200 && res.data) {



                    this.period = res.data



                    this.periodId = res.data.id



                    this.periodName = res.data.periodName



                } else {



                    this.period = null



                    this.periodId = null



                    this.periodName = ''



                }



            }).catch(() => {})



        },



        toggleLottery (val) {



            if (this.lotteryActive === val) return



            this.lotteryActive = val



            this.$router.replace({



                path: this.$route.path,



                query: Object.assign({}, this.$route.query, { preType: val })



            }).catch(() => {})



            this.initPeriod()



        },



        goSubmit () {



            if (!this.periodOperable) {



                this.$message.warning('本期已截止，无法提交')



                return



            }



            if (!this.vuex_token) {



                this.$router.push('/login?redirect=' + encodeURIComponent('/hxwysz/submit?preType=' + this.lotteryActive))



                return



            }



            this.$router.push({ path: '/hxwysz/submit', query: { preType: this.lotteryActive } })



        }



    }



}



</script>







<style lang="scss" scoped>



@import "./audition.scss";



</style>


